// extracted by mini-css-extract-plugin
export var audioPlayer = "_pr-0";